export enum SwapMode {
  ExactInOrOut = 'ExactInOrOut',
  ExactIn = 'ExactIn',
  ExactOut = 'ExactOut',
}
